import React, { ButtonHTMLAttributes } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'outline';
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  loading = false,
  icon,
  children,
  className = '',
  disabled,
  fullWidth = false,
  ...rest
}) => {
  const variantClasses = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    danger: 'btn-error',
    success: 'btn-success',
    outline: 'btn-outline'
  };

  const sizeClasses = {
    small: 'btn-sm',
    medium: 'btn-md',
    large: 'btn-lg'
  };

  const baseClasses = 'btn inline-flex items-center justify-center gap-2 font-medium transition-all duration-200';
  const variantClass = variantClasses[variant] || 'btn-primary';
  const sizeClass = sizeClasses[size] || 'btn-md';
  const loadingClass = loading ? 'loading' : '';
  const widthClass = fullWidth ? 'w-full' : '';
  
  const classNames = [
    baseClasses,
    variantClass,
    sizeClass,
    loadingClass,
    widthClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <button 
      className={classNames} 
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <span className="loading loading-spinner loading-sm"></span>
      ) : icon ? (
        <span className="flex items-center">{icon}</span>
      ) : null}
      {children}
    </button>
  );
};
